export function sendTrackingEvent(data) {
  // send event
  window.dataLayer.push(data);
}
